module.exports = __webpack_public_path__ + "static/media/techlead.ff752535.jpg";